import { render, staticRenderFns } from "./ItemLink.vue?vue&type=template&id=151a8c0e&scoped=true&lang=pug&"
import script from "./ItemLink.vue?vue&type=script&lang=js&"
export * from "./ItemLink.vue?vue&type=script&lang=js&"
import style0 from "./ItemLink.vue?vue&type=style&index=0&id=151a8c0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151a8c0e",
  null
  
)

export default component.exports